import UserService from '../../services/userService'

const user = JSON.parse(sessionStorage.getItem('user'))

const initialState = user
  ? { status: { loggedIn: true }, user, agent: null, currentUser: null }
  : { status: { loggedIn: false }, user: null, agent: null, currentUser: null }

const state = initialState
const mutations = {
  refreshToken(state, accessToken) {
    state.status.loggedIn = true
    state.user = { ...state.user, accessToken: accessToken }
  },
  SET_USER(state) {
    state.user = JSON.parse(sessionStorage.getItem('user'))
  },
  SET_AGENT(state, agent) {
    state.agent = agent
  },
  SET_CURRENT_USER(state, user) {
    state.currentUser = user
  },
  SET_LOGGED_IN(state, payload) {
    state.status.loggedIn = payload
  },
}
const actions = {
  refreshToken({ commit }, accessToken) {
    commit('refreshToken', accessToken)
  },
  async SET_USER({ commit, dispatch }) {
    await dispatch('SET_CURRENT_USER')
    commit('SET_USER')
  },
  SET_CURRENT_USER({ commit }) {
    return UserService.getCurrentUser().then((res) => {
      commit('SET_CURRENT_USER', res.data)
      commit('SET_LOGGED_IN', true)
    })
  },
  SET_LOGGED_IN({ commit }, payload) {
    commit('SET_LOGGED_IN', payload)
  },
}
const getters = {
  GET_AGENT(state) {
    return state.agent
  },
  GET_CURRENT_EMAIL(state) {
    return state.currentUser?.email
  },
  GET_CURRENT_ROLE(state) {
    return state.currentUser?.role
  },
  GET_CURRENT_STATUS(state) {
    return state.currentUser?.status
  },
  GET_CURRENT_USER_UUID(state) {
    return state.currentUser?.uuid
  },
  GET_LOGGED_IN(state) {
    return state.status.loggedIn
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
